/**
 * Predefined Role Constants — UAM Phase 1
 *
 * Superuser / Admin / Viewer are code constants; they are NOT stored in
 * Firestore (see PRD_UAM.md §6.1.2 and PRD_UAM_CustomRoles.md §6.1).
 * Custom roles live in `companies/{companyId}/roles/{roleId}`.
 */

import { PERMISSIONS, ALL_PERMISSIONS } from './permissions';

/**
 * Limits for custom role management. Mirrors functions/src/config/constants.js
 * — keep in sync (not validated by drift guard; small surface).
 * See PRD_UAM_CustomRoles.md §10.
 */
export const ROLE_LIMITS = {
  MAX_CUSTOM_ROLES_PER_COMPANY: 5,
  NAME_MAX: 30,
  DESCRIPTION_MAX: 80,
};

export const PREDEFINED_ROLES = {
  superuser: {
    label: 'Superuser',
    description: 'Full access including billing & payments',
    permissions: ALL_PERMISSIONS,
  },
  admin: {
    label: 'Admin',
    description: 'Full access except billing & payments',
    permissions: ALL_PERMISSIONS.filter(
      p => p !== PERMISSIONS.SETTINGS_PAYMENTS && p !== PERMISSIONS.SETTINGS_PAYMENTS_VIEW,
    ),
  },
  viewer: {
    label: 'Viewer',
    description: 'Read-only access to data',
    permissions: [
      PERMISSIONS.EMPLOYEES_VIEW,
      PERMISSIONS.SCHEDULE_VIEW,
      PERMISSIONS.LOANS_VIEW,
      PERMISSIONS.TIME_TRACKING_VIEW,
      PERMISSIONS.TIME_OT_VIEW,
      PERMISSIONS.PAYROLL_VIEW,
      PERMISSIONS.PAYSLIP_VIEW,
      PERMISSIONS.ADJUSTMENTS_VIEW,
      PERMISSIONS.SETTINGS_DEPARTMENTS_VIEW,
      PERMISSIONS.SETTINGS_TEAM_VIEW,
      PERMISSIONS.SETTINGS_ROLES_VIEW,
      PERMISSIONS.SETTINGS_ATTENDANCE_POLICY_VIEW,
      PERMISSIONS.SETTINGS_HOLIDAYS_VIEW,
      PERMISSIONS.KIOSK_VIEW,
      PERMISSIONS.SETTINGS_PAYROLL_RATES_VIEW,
      PERMISSIONS.SETTINGS_CSV_EXPORT_VIEW,
      PERMISSIONS.SETTINGS_PAYSLIPS_VIEW,
    ],
  },
};

export const getPermissionsForRole = (role) => {
  return PREDEFINED_ROLES[role]?.permissions || [];
};

export const roleHasPermission = (role, permission) => {
  return getPermissionsForRole(role).includes(permission);
};
